import { Api as api } from "../api";
const prefix = "/master-data";
// const prefix = "";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    vehicleModelServiceV1ListTollClasses: build.query<
      VehicleModelServiceV1ListTollClassesApiResponse,
      VehicleModelServiceV1ListTollClassesApiArg
    >({
      query: () => ({ url: `${prefix}/v1/toll-classes` }),
    }),
    vehicleModelServiceV1ListVehicleModels: build.query<
      VehicleModelServiceV1ListVehicleModelsApiResponse,
      VehicleModelServiceV1ListVehicleModelsApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vehicle-models`,
        params: {
          page: queryArg.page,
          size: queryArg.size,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
          status: queryArg.status,
          vehicle_model: queryArg.vehicleModel,
          vehicle_type_id: queryArg.vehicleTypeId,
          toll_class_id: queryArg.tollClassId,
          created_at_from: queryArg.createdAtFrom,
          created_at_to: queryArg.createdAtTo,
          updated_at_from: queryArg.updatedAtFrom,
          updated_at_to: queryArg.updatedAtTo,
          vehicle_type: queryArg.vehicleType,
          freezer_model: queryArg.freezerModel,
          tyre_count: queryArg.tyreCount,
          tyre_size: queryArg.tyreSize,
          axle_count: queryArg.axleCount,
          fuel_capacity: queryArg.fuelCapacity,
        },
      }),
    }),
    vehicleModelServiceV1BatchCreateVehicleModel: build.mutation<
      VehicleModelServiceV1BatchCreateVehicleModelApiResponse,
      VehicleModelServiceV1BatchCreateVehicleModelApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vehicle-models`,
        method: "POST",
        body: queryArg.vehicleModelV1BatchCreateVehicleModelReq,
      }),
    }),
    vehicleModelServiceV1ActivateVehicleModels: build.mutation<
      VehicleModelServiceV1ActivateVehicleModelsApiResponse,
      VehicleModelServiceV1ActivateVehicleModelsApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vehicle-models/activate`,
        method: "PATCH",
        body: queryArg.vehicleModelV1VehicleModelBulkStatusChangeReq,
      }),
    }),
    vehicleModelServiceV1GetVehicleModelDropdown: build.query<
      VehicleModelServiceV1GetVehicleModelDropdownApiResponse,
      VehicleModelServiceV1GetVehicleModelDropdownApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vehicle-models/dropdown`,
        params: {
          vehicle_type_id: queryArg.vehicleTypeId,
        },
      }),
    }),
    vehicleModelServiceV1GetFreezerModelDropdown: build.query<
      VehicleModelServiceV1GetFreezerModelDropdownApiResponse,
      VehicleModelServiceV1GetFreezerModelDropdownApiArg
    >({
      query: () => ({ url: `${prefix}/v1/vehicle-models/freezer-models/dropdown` }),
    }),
    vehicleModelServiceV1GetFuelTypeDropdown: build.query<
      VehicleModelServiceV1GetFuelTypeDropdownApiResponse,
      VehicleModelServiceV1GetFuelTypeDropdownApiArg
    >({
      query: () => ({ url: `${prefix}/v1/vehicle-models/fuel-types/dropdown` }),
    }),
    vehicleModelServiceV1ImportVehicleModels: build.mutation<
      VehicleModelServiceV1ImportVehicleModelsApiResponse,
      VehicleModelServiceV1ImportVehicleModelsApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vehicle-models/import`,
        method: "POST",
        body: queryArg.apiHttpBody,
      }),
    }),
    vehicleModelServiceV1DownloadVehicleModelImportTemplate: build.query<
      VehicleModelServiceV1DownloadVehicleModelImportTemplateApiResponse,
      VehicleModelServiceV1DownloadVehicleModelImportTemplateApiArg
    >({
      query: () => ({ url: `${prefix}/v1/vehicle-models/import/template` }),
    }),
    vehicleModelServiceV1DeactivateVehicleModels: build.mutation<
      VehicleModelServiceV1DeactivateVehicleModelsApiResponse,
      VehicleModelServiceV1DeactivateVehicleModelsApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vehicle-models/inactive`,
        method: "PATCH",
        body: queryArg.vehicleModelV1VehicleModelBulkStatusChangeReq,
      }),
    }),
    vehicleModelServiceV1GetVehicleTypeDropdown: build.query<
      VehicleModelServiceV1GetVehicleTypeDropdownApiResponse,
      VehicleModelServiceV1GetVehicleTypeDropdownApiArg
    >({
      query: () => ({ url: `${prefix}/v1/vehicle-models/vehicle-types/dropdown` }),
    }),
    vehicleModelServiceV1GetVehicleModel: build.query<
      VehicleModelServiceV1GetVehicleModelApiResponse,
      VehicleModelServiceV1GetVehicleModelApiArg
    >({
      query: (queryArg) => ({ url: `${prefix}/v1/vehicle-models/${queryArg.id}` }),
    }),
    vehicleModelServiceV1UpdateVehicleModel: build.mutation<
      VehicleModelServiceV1UpdateVehicleModelApiResponse,
      VehicleModelServiceV1UpdateVehicleModelApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vehicle-models/${queryArg.id}`,
        method: "PUT",
        body: queryArg.vehicleModelServiceV1UpdateVehicleModelBody,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as vehicleModelApi };
export type VehicleModelServiceV1ListTollClassesApiResponse =
  /** status 200 A successful response. */ VehicleModelV1ListTollClassesRes;
export type VehicleModelServiceV1ListTollClassesApiArg = void;
export type VehicleModelServiceV1ListVehicleModelsApiResponse =
  /** status 200 A successful response. */ VehicleModelV1ListVehicleModelsRes;
export type VehicleModelServiceV1ListVehicleModelsApiArg = {
  page?: number;
  size?: number;
  sortBy?: string;
  sortOrder?: string;
  status?: string;
  vehicleModel?: string;
  vehicleTypeId?: string;
  tollClassId?: string;
  createdAtFrom?: string;
  createdAtTo?: string;
  updatedAtFrom?: string;
  updatedAtTo?: string;
  vehicleType?: string;
  freezerModel?: string;
  tyreCount?: number;
  tyreSize?: string;
  axleCount?: number;
  fuelCapacity?: number;
};
export type VehicleModelServiceV1BatchCreateVehicleModelApiResponse =
  /** status 200 A successful response. */ VehicleModelV1VehicleModelMessageRes;
export type VehicleModelServiceV1BatchCreateVehicleModelApiArg = {
  vehicleModelV1BatchCreateVehicleModelReq: VehicleModelV1BatchCreateVehicleModelReq;
};
export type VehicleModelServiceV1ActivateVehicleModelsApiResponse =
  /** status 200 A successful response. */ VehicleModelV1VehicleModelBulkStatusChangeRes;
export type VehicleModelServiceV1ActivateVehicleModelsApiArg = {
  vehicleModelV1VehicleModelBulkStatusChangeReq: VehicleModelV1VehicleModelBulkStatusChangeReq;
};
export type VehicleModelServiceV1GetVehicleModelDropdownApiResponse =
  /** status 200 A successful response. */ VehicleModelV1GetVehicleModelDropdownRes;
export type VehicleModelServiceV1GetVehicleModelDropdownApiArg = {
  vehicleTypeId?: string;
};
export type VehicleModelServiceV1GetFreezerModelDropdownApiResponse =
  /** status 200 A successful response. */ VehicleModelV1GetFreezerModelDropdownForModelRes;
export type VehicleModelServiceV1GetFreezerModelDropdownApiArg = void;
export type VehicleModelServiceV1GetFuelTypeDropdownApiResponse =
  /** status 200 A successful response. */ VehicleModelV1GetFuelTypeDropdownForModelRes;
export type VehicleModelServiceV1GetFuelTypeDropdownApiArg = void;
export type VehicleModelServiceV1ImportVehicleModelsApiResponse =
  /** status 200 A successful response. */ VehicleModelV1ImportVehicleModelsRes;
export type VehicleModelServiceV1ImportVehicleModelsApiArg = {
  /** Message that represents an arbitrary HTTP body. It should only be used for
    payload formats that can't be represented as JSON, such as raw binary or
    an HTML page.
    
    
    This message can be used both in streaming and non-streaming API methods in
    the request as well as the response.
    
    It can be used as a top-level request field, which is convenient if one
    wants to extract parameters from either the URL or HTTP template into the
    request fields and also want access to the raw HTTP body.
    
    Example:
    
        message GetResourceRequest {
          // A unique request id.
          string request_id = 1;
    
          // The raw HTTP body is bound to this field.
          google.api.HttpBody http_body = 2;
        }
    
        service ResourceService {
          rpc GetResource(GetResourceRequest) returns (google.api.HttpBody);
          rpc UpdateResource(google.api.HttpBody) returns
          (google.protobuf.Empty);
        }
    
    Example with streaming methods:
    
        service CaldavService {
          rpc GetCalendar(stream google.api.HttpBody)
            returns (stream google.api.HttpBody);
          rpc UpdateCalendar(stream google.api.HttpBody)
            returns (stream google.api.HttpBody);
        }
    
    Use of this type only changes how the request and response bodies are
    handled, all other features will continue to work unchanged. */
  apiHttpBody: ApiHttpBody;
};
export type VehicleModelServiceV1DownloadVehicleModelImportTemplateApiResponse =
  unknown;
export type VehicleModelServiceV1DownloadVehicleModelImportTemplateApiArg =
  void;
export type VehicleModelServiceV1DeactivateVehicleModelsApiResponse =
  /** status 200 A successful response. */ VehicleModelV1VehicleModelBulkStatusChangeRes;
export type VehicleModelServiceV1DeactivateVehicleModelsApiArg = {
  vehicleModelV1VehicleModelBulkStatusChangeReq: VehicleModelV1VehicleModelBulkStatusChangeReq;
};
export type VehicleModelServiceV1GetVehicleTypeDropdownApiResponse =
  /** status 200 A successful response. */ VehicleModelV1GetVehicleTypeDropdownForModelRes;
export type VehicleModelServiceV1GetVehicleTypeDropdownApiArg = void;
export type VehicleModelServiceV1GetVehicleModelApiResponse =
  /** status 200 A successful response. */ VehicleModelV1VehicleModelDetailRes;
export type VehicleModelServiceV1GetVehicleModelApiArg = {
  id: string;
};
export type VehicleModelServiceV1UpdateVehicleModelApiResponse =
  /** status 200 A successful response. */ VehicleModelV1VehicleModelMessageRes;
export type VehicleModelServiceV1UpdateVehicleModelApiArg = {
  id: string;
  vehicleModelServiceV1UpdateVehicleModelBody: VehicleModelServiceV1UpdateVehicleModelBody;
};
export type VehicleModelV1TollClassRes = {
  id?: string;
  name?: string;
};
export type VehicleModelV1ListTollClassesRes = {
  toll_classes?: VehicleModelV1TollClassRes[];
};
export type ProtobufAny = {
  /** A URL/resource name that uniquely identifies the type of the serialized
    protocol buffer message. This string must contain at least
    one "/" character. The last segment of the URL's path must represent
    the fully qualified name of the type (as in
    `path/google.protobuf.Duration`). The name should be in a canonical form
    (e.g., leading "." is not accepted).
    
    In practice, teams usually precompile into the binary all types that they
    expect it to use in the context of Any. However, for URLs which use the
    scheme `http`, `https`, or no scheme, one can optionally set up a type
    server that maps type URLs to message definitions as follows:
    
    * If no scheme is provided, `https` is assumed.
    * An HTTP GET on the URL must yield a [google.protobuf.Type][]
      value in binary format, or produce an error.
    * Applications are allowed to cache lookup results based on the
      URL, or have them precompiled into a binary to avoid any
      lookup. Therefore, binary compatibility needs to be preserved
      on changes to types. (Use versioned type names to manage
      breaking changes.)
    
    Note: this functionality is not currently available in the official
    protobuf release, and it is not used for type URLs beginning with
    type.googleapis.com. As of May 2023, there are no widely used type server
    implementations and no plans to implement one.
    
    Schemes other than `http`, `https` (or the empty scheme) might be
    used with implementation specific semantics. */
  "@type"?: string;
  [key: string]: any;
};
export type RpcStatus = {
  code?: number;
  message?: string;
  details?: ProtobufAny[];
};
export type VehicleModelV1VehicleModelRes = {
  id?: string;
  vehicle_model?: string;
  vehicle_type_id?: string;
  vehicle_type_name?: string;
  freezer_model_id?: string;
  freezer_model_name?: string;
  tyre_count?: number;
  tyre_size?: string;
  axle_count?: number;
  toll_class_id?: string;
  toll_class_name?: string;
  fuel_capacity?: number;
  total_fleet?: number;
  status?: string;
  created_by?: string;
  updated_by?: string;
  created_at?: string;
  updated_at?: string;
  fuel_type_id?: string;
  fuel_type_name?: string;
};
export type VehicleModelV1VehicleModelPaginationMeta = {
  total?: number;
  current_page?: number;
  limit?: number;
  total_item?: number;
  total_page?: number;
  have_next_page?: boolean;
  have_previous_page?: boolean;
};
export type VehicleModelV1ListVehicleModelsRes = {
  vehicle_models?: VehicleModelV1VehicleModelRes[];
  metadata?: VehicleModelV1VehicleModelPaginationMeta;
};
export type VehicleModelV1VehicleModelMessageRes = {
  message?: string;
  id?: string;
};
export type VehicleModelV1CreateVehicleModelItem = {
  vehicle_model: string;
  vehicle_type_id: string;
  freezer_model_id?: string;
  tyre_count: number;
  tyre_size?: string;
  axle_count: number;
  toll_class_id: string;
  fuel_capacity?: number;
  total_fleet?: number;
  status: string;
  fuel_type_id?: string;
};
export type VehicleModelV1BatchCreateVehicleModelReq = {
  items: VehicleModelV1CreateVehicleModelItem[];
};
export type VehicleModelV1VehicleModelBulkStatusChangeRes = {
  message?: string;
  updated_count?: number;
};
export type VehicleModelV1VehicleModelBulkStatusChangeReq = {
  ids: string[];
};
export type VehicleModelV1VehicleModelDropdownItemRes = {
  id?: string;
  name?: string;
  vehicle_type_id?: string;
  freezer_model_id?: string;
  freezer_model_name?: string;
};
export type VehicleModelV1GetVehicleModelDropdownRes = {
  vehicle_models?: VehicleModelV1VehicleModelDropdownItemRes[];
};
export type VehicleModelV1FreezerModelDropdownItemForModelRes = {
  id?: string;
  name?: string;
  freezer_brand_id?: string;
  freezer_brand_name?: string;
};
export type VehicleModelV1GetFreezerModelDropdownForModelRes = {
  freezer_models?: VehicleModelV1FreezerModelDropdownItemForModelRes[];
};
export type VehicleModelV1FuelTypeDropdownItemForModelRes = {
  id?: string;
  fuel_type_name?: string;
};
export type VehicleModelV1GetFuelTypeDropdownForModelRes = {
  fuel_types?: VehicleModelV1FuelTypeDropdownItemForModelRes[];
};
export type VehicleModelV1ImportRowError = {
  row?: number;
  field?: string;
  message?: string;
};
export type VehicleModelV1ImportVehicleModelsRes = {
  success?: boolean;
  imported_count?: number;
  message?: string;
  errors?: VehicleModelV1ImportRowError[];
};
export type ApiHttpBody = {
  /** The HTTP Content-Type header value specifying the content type of the body. */
  contentType?: string;
  /** The HTTP request/response body as raw binary. */
  data?: string;
  /** Application specific response metadata. Must be set in the first response
    for streaming APIs. */
  extensions?: ProtobufAny[];
};
export type VehicleModelV1VehicleTypeDropdownItemForModelRes = {
  id?: string;
  name?: string;
  category?: string;
  is_add_on?: boolean;
  temp_type_id?: string;
  temp_type_name?: string;
  is_freezer?: boolean;
};
export type VehicleModelV1GetVehicleTypeDropdownForModelRes = {
  vehicle_types?: VehicleModelV1VehicleTypeDropdownItemForModelRes[];
};
export type VehicleModelV1VehicleModelDetailRes = {
  id?: string;
  vehicle_model?: string;
  vehicle_type_id?: string;
  vehicle_type_name?: string;
  freezer_model_id?: string;
  freezer_model_name?: string;
  tyre_count?: number;
  tyre_size?: string;
  axle_count?: number;
  toll_class_id?: string;
  toll_class_name?: string;
  fuel_capacity?: number;
  total_fleet?: number;
  status?: string;
  created_by?: string;
  updated_by?: string;
  created_at?: string;
  updated_at?: string;
  fuel_type_id?: string;
  fuel_type_name?: string;
};
export type VehicleModelServiceV1UpdateVehicleModelBody = {
  vehicle_model: string;
  vehicle_type_id: string;
  tyre_count: number;
  tyre_size?: string;
  axle_count: number;
  toll_class_id: string;
  fuel_capacity?: number;
  total_fleet?: number;
  status?: string;
  fuel_type_id?: string;
};
export const {
  useVehicleModelServiceV1ListTollClassesQuery,
  useVehicleModelServiceV1ListVehicleModelsQuery,
  useVehicleModelServiceV1BatchCreateVehicleModelMutation,
  useVehicleModelServiceV1ActivateVehicleModelsMutation,
  useVehicleModelServiceV1GetVehicleModelDropdownQuery,
  useVehicleModelServiceV1GetFreezerModelDropdownQuery,
  useVehicleModelServiceV1GetFuelTypeDropdownQuery,
  useVehicleModelServiceV1ImportVehicleModelsMutation,
  useVehicleModelServiceV1DownloadVehicleModelImportTemplateQuery,
  useVehicleModelServiceV1DeactivateVehicleModelsMutation,
  useVehicleModelServiceV1GetVehicleTypeDropdownQuery,
  useVehicleModelServiceV1GetVehicleModelQuery,
  useVehicleModelServiceV1UpdateVehicleModelMutation,
} = injectedRtkApi;
